import { Platform } from '@angular/cdk/platform';
import { Injectable, Signal, inject } from '@angular/core';
import { Store } from '@ngrx/store';

import { MediaFormatImage } from '../models/media.models';

import { getCmsConfigValue } from '@core/infrastructure/state/core.selectors';

@Injectable({ providedIn: 'root' })
export class ImageMediaService {
    private readonly store: Store = inject(Store);

    private readonly platform = inject(Platform);

    private readonly waterMark$$: Signal<boolean> = this.store.selectSignal(getCmsConfigValue('enable_marketing_act'));

    public onlyOnePriorityImgLoaded = true;

    private firstCarouselAnimated = false;

    public getConfigWaterMark(): boolean {
        // biome-ignore lint/complexity/useSimplifiedLogicExpression: <explanation>
        return this.waterMark$$() || false;
    }

    public platformFormatImage(serverImg): MediaFormatImage {
        if (serverImg) {
            return MediaFormatImage.JPG;
        }
        return this.platform.SAFARI || this.platform.EDGE || this.platform.BLINK
            ? MediaFormatImage.WEBP : MediaFormatImage.JPG;
    }

    public hasAmandaSrc(url: string): boolean {
        return url?.includes('assets/public');
    }

    public setImgPriority() {
        this.onlyOnePriorityImgLoaded = false;
    }

    public isFirstCarousel(): boolean {
        if (!this.firstCarouselAnimated) {
            this.firstCarouselAnimated = true;
            return true;
        }
        return false;
    }
}
